module.exports = __webpack_public_path__ + "img/IMG_0079_L_Foamcore_MockedUp.97f8f1e7.jpg";